export const ORDER_STATUS_COLORS = {
  '0': '#ffcc00',
  '1': '#999999',
  '2': '#ff9932',
  '3': '#ff9933',
  '4': '#f00',
  '5': '#0066ff',
  '6': '#329900',
  '7': '#06f',
  '8': '#393',
  '9': '#393',
  '-1': '#ff0000',
};
